module.exports = __webpack_public_path__ + "img/paper-5.08d203d1.png";